import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ConsentGuard = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div style={styles.container}>
        <div style={styles.loading}>Loading...</div>
      </div>
    );
  }

  // Require the consent sheet once per login session. The flag is cleared on
  // every login (see AuthContext.login), so participants re-consent each time
  // they log in, while a mid-session page reload does not force it again.
  let consentedThisSession = false;
  try { consentedThisSession = sessionStorage.getItem('consent_ack') === 'true'; } catch (_) {}

  if (user && !consentedThisSession) {
    return <Navigate to="/consent" replace />;
  }

  return children;
};

const styles = {
  container: {
    height: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  loading: {
    fontSize: '18px',
    color: '#6b7280',
  },
};

export default ConsentGuard;




